// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================
   PAGE
===================================== */

.admin-user-details-page {
    width: 100%;
    max-width: 1200px;
  
    margin: 0 auto;
  
    min-width: 0;
  }
  
  
  /* =====================================
     BACK BUTTON
  ===================================== */
  
  .admin-details-back {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  
    margin-bottom: 24px;
    padding: 0;
  
    border: none;
    background: none;
  
    font-size: 14px;
    font-weight: 500;
  
    color: #667085;
  
    cursor: pointer;
  }
  
  
  .admin-details-back:hover {
    color: #111827;
  }
  
  
  /* =====================================
     HEADING
  ===================================== */
  
  .admin-details-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  
    margin-bottom: 28px;
  }
  
  
  .admin-details-heading h1 {
    margin: 0;
  
    font-size: clamp(
      23px,
      4vw,
      30px
    );
  
    font-weight: 700;
  
    color: #101828;
  
    overflow-wrap: anywhere;
  }
  
  
  .admin-details-heading p {
    margin: 7px 0 0;
  
    font-size: 14px;
  
    color: #667085;
  
    overflow-wrap: anywhere;
  }
  
  
  /* =====================================
     STATUS
  ===================================== */
  
  .admin-details-status {
    display: inline-flex;
    align-items: center;
  
    flex-shrink: 0;
  
    padding: 7px 12px;
  
    border-radius: 999px;
  
    font-size: 13px;
    font-weight: 600;
  
    white-space: nowrap;
  }
  
  
  .admin-details-status.pending {
    background: #fff7e6;
    color: #b54708;
  }
  
  
  .admin-details-status.verified {
    background: #ecfdf3;
    color: #027a48;
  }
  
  
  .admin-details-status.rejected {
    background: #fef3f2;
    color: #b42318;
  }
  
  
  /* =====================================
     SECTIONS
  ===================================== */
  
  .admin-details-section {
    margin-bottom: 22px;
  
    padding: 24px;
  
    background: #ffffff;
  
    border:
      1px solid #e8eaf0;
  
    border-radius: 14px;
  
    box-sizing: border-box;
  }
  
  
  .admin-details-section h2 {
    margin:
      0 0 22px;
  
    font-size: 18px;
    font-weight: 650;
  
    color: #101828;
  }
  
  
  /* =====================================
     GRID
  ===================================== */
  
  .admin-details-grid {
    display: grid;
  
    grid-template-columns:
      repeat(
        3,
        minmax(0, 1fr)
      );
  
    gap: 20px;
  }
  
  
  /* =====================================
     INFO ITEM
  ===================================== */
  
  .admin-info-item {
    min-width: 0;
  
    display: flex;
    flex-direction: column;
  
    gap: 6px;
  }
  
  
  .admin-info-item span {
    font-size: 12px;
    font-weight: 500;
  
    color: #667085;
  }
  
  
  .admin-info-item strong {
    font-size: 14px;
    font-weight: 600;
  
    color: #101828;
  
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  
  
  /* =====================================
     EMPTY
  ===================================== */
  
  .admin-details-empty,
  .admin-documents-empty {
    padding: 18px;
  
    background: #f8fafc;
  
    border-radius: 10px;
  
    font-size: 14px;
    line-height: 1.6;
  
    color: #667085;
  }
  
  
  /* =====================================
     DOCUMENTS
  ===================================== */
  
  .admin-documents-list {
    display: flex;
    flex-direction: column;
  
    gap: 12px;
  }
  
  
  .admin-document-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
  
    gap: 20px;
  
    padding: 16px;
  
    border:
      1px solid #e8eaf0;
  
    border-radius: 12px;
  
    background: #ffffff;
  
    min-width: 0;
  }
  
  
  .admin-document-info {
    display: flex;
    align-items: center;
  
    gap: 13px;
  
    min-width: 0;
    flex: 1 1;
  }
  
  
  .admin-document-icon {
    width: 42px;
    height: 42px;
  
    flex-shrink: 0;
  
    display: flex;
    align-items: center;
    justify-content: center;
  
    border-radius: 10px;
  
    background: #f2f4f7;
  
    color: #475467;
  }
  
  
  .admin-document-info > div:last-child {
    min-width: 0;
  }
  
  
  .admin-document-info strong {
    display: block;
  
    margin-bottom: 4px;
  
    font-size: 14px;
  
    color: #101828;
  
    overflow-wrap: anywhere;
  }
  
  
  .admin-document-info span {
    display: block;
  
    max-width: 420px;
  
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  
    font-size: 12px;
  
    color: #667085;
  }
  
  
  /* =====================================
     DOCUMENT ACTIONS
  ===================================== */
  
  .admin-document-actions {
    display: flex;
    align-items: center;
  
    gap: 8px;
  
    flex-shrink: 0;
  }
  
  
  .admin-document-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  
    gap: 7px;
  
    padding: 8px 11px;
  
    border:
      1px solid #d0d5dd;
  
    border-radius: 8px;
  
    background: #ffffff;
  
    text-decoration: none;
  
    font-size: 12px;
    font-weight: 600;
  
    color: #344054;
  
    white-space: nowrap;
  }
  
  
  .admin-document-button:hover {
    background: #f9fafb;
  }
  
  
  /* =====================================
     REVIEW ACTIONS
  ===================================== */
  
  .admin-review-actions {
    display: flex;
    justify-content: flex-end;
  
    gap: 12px;
  
    padding:
      20px 0 40px;
  }
  
  
  .admin-delete-button,
  .admin-reject-button,
  .admin-verify-button {
    min-height: 44px;
  
    padding:
      12px 18px;
  
    border-radius: 10px;
  
    font-size: 14px;
    font-weight: 600;
  
    cursor: pointer;
  }

  .admin-delete-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: 1px solid #b42318;
    background: #b42318;
    color: #ffffff;
    box-shadow: 0 8px 18px rgba(180, 35, 24, 0.18);
  }

  .admin-delete-button:hover {
    border-color: #912018;
    background: #912018;
  }
  
  
  .admin-reject-button {
    border:
      1px solid #f04438;
  
    background: #ffffff;
  
    color: #d92d20;
  }
  
  
  .admin-reject-button:hover {
    background: #fef3f2;
  }
  
  
  .admin-verify-button {
    border:
      1px solid #1570ef;
  
    background: #1570ef;
  
    color: #ffffff;
  }
  
  
  .admin-verify-button:hover {
    background: #175cd3;
  }
  
  
  .admin-delete-button:disabled,
  .admin-reject-button:disabled,
  .admin-verify-button:disabled {
    opacity: 0.6;
  
    cursor: not-allowed;
  }
  
  
  /* =====================================
     STATES
  ===================================== */
  
  .admin-details-state,
  .admin-details-error {
    padding: 40px 20px;
  
    background: #ffffff;
  
    border:
      1px solid #e8eaf0;
  
    border-radius: 14px;
  
    text-align: center;
  }
  
  
  .admin-details-state {
    color: #667085;
  }
  
  
  .admin-details-error {
    color: #b42318;
  }
  
  
  /* =====================================
     SMALL LAPTOP / TABLET
  ===================================== */
  
  @media (max-width: 1100px) {
  
    .admin-details-grid {
      grid-template-columns:
        repeat(
          2,
          minmax(0, 1fr)
        );
    }
  
  }
  
  
  /* =====================================
     TABLET
  ===================================== */
  
  @media (max-width: 800px) {
  
    .admin-details-heading {
      align-items: flex-start;
    }
  
  
    .admin-details-section {
      padding: 20px;
    }
  
  
    .admin-document-card {
      align-items: flex-start;
      flex-direction: column;
    }
  
  
    .admin-document-actions {
      width: 100%;
    }
  
  
    .admin-document-button {
      flex: 1 1;
    }
  
  }
  
  
  /* =====================================
     MOBILE
  ===================================== */
  
  @media (max-width: 600px) {
  
    .admin-details-back {
      margin-bottom: 18px;
  
      font-size: 13px;
    }
  
  
    .admin-details-heading {
      align-items: flex-start;
      flex-direction: column;
  
      gap: 12px;
  
      margin-bottom: 20px;
    }
  
  
    .admin-details-grid {
      grid-template-columns:
        1fr;
  
      gap: 16px;
    }
  
  
    .admin-details-section {
      margin-bottom: 14px;
  
      padding: 18px 16px;
  
      border-radius: 12px;
    }
  
  
    .admin-details-section h2 {
      margin-bottom: 18px;
  
      font-size: 16px;
    }
  
  
    .admin-document-card {
      padding: 14px;
    }
  
  
    .admin-document-info {
      align-items: flex-start;
  
      width: 100%;
    }
  
  
    .admin-document-info span {
      max-width: 100%;
    }
  
  
    .admin-document-actions {
      display: grid;
  
      grid-template-columns:
        repeat(
          2,
          minmax(0, 1fr)
        );
  
      width: 100%;
    }
  
  
    .admin-document-button {
      min-width: 0;
  
      padding:
        10px 8px;
    }
  
  
    .admin-review-actions {
      position: sticky;
  
      bottom: 0;
  
      z-index: 500;
  
      flex-direction: column-reverse;
  
      gap: 9px;
  
      margin:
        0 -14px;
  
      padding:
        14px;
  
      background:
        rgba(
          246,
          247,
          251,
          0.96
        );
  
      border-top:
        1px solid #e8eaf0;
  
      backdrop-filter:
        blur(10px);
    }
  
  
    .admin-delete-button,
    .admin-reject-button,
    .admin-verify-button {
      width: 100%;
  
      min-height: 46px;
    }
  
  }
  
  
  /* =====================================
     VERY SMALL MOBILE
  ===================================== */
  
  @media (max-width: 380px) {
  
    .admin-details-section {
      padding:
        16px 13px;
    }
  
  
    .admin-document-actions {
      grid-template-columns:
        1fr;
    }
  
  
    .admin-review-actions {
      margin:
        0 -10px;
  
      padding:
        10px;
    }
  
  }
`, "",{"version":3,"sources":["webpack://./src/admin/styles/AdminUserDetails.css"],"names":[],"mappings":"AAAA;;uCAEuC;;AAEvC;IACI,WAAW;IACX,iBAAiB;;IAEjB,cAAc;;IAEd,YAAY;EACd;;;EAGA;;yCAEuC;;EAEvC;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;;IAER,mBAAmB;IACnB,UAAU;;IAEV,YAAY;IACZ,gBAAgB;;IAEhB,eAAe;IACf,gBAAgB;;IAEhB,cAAc;;IAEd,eAAe;EACjB;;;EAGA;IACE,cAAc;EAChB;;;EAGA;;yCAEuC;;EAEvC;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;;IAET,mBAAmB;EACrB;;;EAGA;IACE,SAAS;;IAET;;;;KAIC;;IAED,gBAAgB;;IAEhB,cAAc;;IAEd,uBAAuB;EACzB;;;EAGA;IACE,eAAe;;IAEf,eAAe;;IAEf,cAAc;;IAEd,uBAAuB;EACzB;;;EAGA;;yCAEuC;;EAEvC;IACE,oBAAoB;IACpB,mBAAmB;;IAEnB,cAAc;;IAEd,iBAAiB;;IAEjB,oBAAoB;;IAEpB,eAAe;IACf,gBAAgB;;IAEhB,mBAAmB;EACrB;;;EAGA;IACE,mBAAmB;IACnB,cAAc;EAChB;;;EAGA;IACE,mBAAmB;IACnB,cAAc;EAChB;;;EAGA;IACE,mBAAmB;IACnB,cAAc;EAChB;;;EAGA;;yCAEuC;;EAEvC;IACE,mBAAmB;;IAEnB,aAAa;;IAEb,mBAAmB;;IAEnB;uBACmB;;IAEnB,mBAAmB;;IAEnB,sBAAsB;EACxB;;;EAGA;IACE;cACU;;IAEV,eAAe;IACf,gBAAgB;;IAEhB,cAAc;EAChB;;;EAGA;;yCAEuC;;EAEvC;IACE,aAAa;;IAEb;;;;OAIG;;IAEH,SAAS;EACX;;;EAGA;;yCAEuC;;EAEvC;IACE,YAAY;;IAEZ,aAAa;IACb,sBAAsB;;IAEtB,QAAQ;EACV;;;EAGA;IACE,eAAe;IACf,gBAAgB;;IAEhB,cAAc;EAChB;;;EAGA;IACE,eAAe;IACf,gBAAgB;;IAEhB,cAAc;;IAEd,uBAAuB;IACvB,sBAAsB;EACxB;;;EAGA;;yCAEuC;;EAEvC;;IAEE,aAAa;;IAEb,mBAAmB;;IAEnB,mBAAmB;;IAEnB,eAAe;IACf,gBAAgB;;IAEhB,cAAc;EAChB;;;EAGA;;yCAEuC;;EAEvC;IACE,aAAa;IACb,sBAAsB;;IAEtB,SAAS;EACX;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,SAAS;;IAET,aAAa;;IAEb;uBACmB;;IAEnB,mBAAmB;;IAEnB,mBAAmB;;IAEnB,YAAY;EACd;;;EAGA;IACE,aAAa;IACb,mBAAmB;;IAEnB,SAAS;;IAET,YAAY;IACZ,SAAO;EACT;;;EAGA;IACE,WAAW;IACX,YAAY;;IAEZ,cAAc;;IAEd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,mBAAmB;;IAEnB,mBAAmB;;IAEnB,cAAc;EAChB;;;EAGA;IACE,YAAY;EACd;;;EAGA;IACE,cAAc;;IAEd,kBAAkB;;IAElB,eAAe;;IAEf,cAAc;;IAEd,uBAAuB;EACzB;;;EAGA;IACE,cAAc;;IAEd,gBAAgB;;IAEhB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;;IAEf,cAAc;EAChB;;;EAGA;;yCAEuC;;EAEvC;IACE,aAAa;IACb,mBAAmB;;IAEnB,QAAQ;;IAER,cAAc;EAChB;;;EAGA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;;IAEvB,QAAQ;;IAER,iBAAiB;;IAEjB;uBACmB;;IAEnB,kBAAkB;;IAElB,mBAAmB;;IAEnB,qBAAqB;;IAErB,eAAe;IACf,gBAAgB;;IAEhB,cAAc;;IAEd,mBAAmB;EACrB;;;EAGA;IACE,mBAAmB;EACrB;;;EAGA;;yCAEuC;;EAEvC;IACE,aAAa;IACb,yBAAyB;;IAEzB,SAAS;;IAET;iBACa;EACf;;;EAGA;;;IAGE,gBAAgB;;IAEhB;eACW;;IAEX,mBAAmB;;IAEnB,eAAe;IACf,gBAAgB;;IAEhB,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,8CAA8C;EAChD;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;;EAGA;IACE;uBACmB;;IAEnB,mBAAmB;;IAEnB,cAAc;EAChB;;;EAGA;IACE,mBAAmB;EACrB;;;EAGA;IACE;uBACmB;;IAEnB,mBAAmB;;IAEnB,cAAc;EAChB;;;EAGA;IACE,mBAAmB;EACrB;;;EAGA;;;IAGE,YAAY;;IAEZ,mBAAmB;EACrB;;;EAGA;;yCAEuC;;EAEvC;;IAEE,kBAAkB;;IAElB,mBAAmB;;IAEnB;uBACmB;;IAEnB,mBAAmB;;IAEnB,kBAAkB;EACpB;;;EAGA;IACE,cAAc;EAChB;;;EAGA;IACE,cAAc;EAChB;;;EAGA;;yCAEuC;;EAEvC;;IAEE;MACE;;;;SAIG;IACL;;EAEF;;;EAGA;;yCAEuC;;EAEvC;;IAEE;MACE,uBAAuB;IACzB;;;IAGA;MACE,aAAa;IACf;;;IAGA;MACE,uBAAuB;MACvB,sBAAsB;IACxB;;;IAGA;MACE,WAAW;IACb;;;IAGA;MACE,SAAO;IACT;;EAEF;;;EAGA;;yCAEuC;;EAEvC;;IAEE;MACE,mBAAmB;;MAEnB,eAAe;IACjB;;;IAGA;MACE,uBAAuB;MACvB,sBAAsB;;MAEtB,SAAS;;MAET,mBAAmB;IACrB;;;IAGA;MACE;WACK;;MAEL,SAAS;IACX;;;IAGA;MACE,mBAAmB;;MAEnB,kBAAkB;;MAElB,mBAAmB;IACrB;;;IAGA;MACE,mBAAmB;;MAEnB,eAAe;IACjB;;;IAGA;MACE,aAAa;IACf;;;IAGA;MACE,uBAAuB;;MAEvB,WAAW;IACb;;;IAGA;MACE,eAAe;IACjB;;;IAGA;MACE,aAAa;;MAEb;;;;SAIG;;MAEH,WAAW;IACb;;;IAGA;MACE,YAAY;;MAEZ;gBACU;IACZ;;;IAGA;MACE,gBAAgB;;MAEhB,SAAS;;MAET,YAAY;;MAEZ,8BAA8B;;MAE9B,QAAQ;;MAER;eACS;;MAET;YACM;;MAEN;;;;;;SAMG;;MAEH;yBACmB;;MAEnB;kBACY;IACd;;;IAGA;;;MAGE,WAAW;;MAEX,gBAAgB;IAClB;;EAEF;;;EAGA;;yCAEuC;;EAEvC;;IAEE;MACE;iBACW;IACb;;;IAGA;MACE;WACK;IACP;;;IAGA;MACE;eACS;;MAET;YACM;IACR;;EAEF","sourcesContent":["/* =====================================\n   PAGE\n===================================== */\n\n.admin-user-details-page {\n    width: 100%;\n    max-width: 1200px;\n  \n    margin: 0 auto;\n  \n    min-width: 0;\n  }\n  \n  \n  /* =====================================\n     BACK BUTTON\n  ===================================== */\n  \n  .admin-details-back {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n  \n    margin-bottom: 24px;\n    padding: 0;\n  \n    border: none;\n    background: none;\n  \n    font-size: 14px;\n    font-weight: 500;\n  \n    color: #667085;\n  \n    cursor: pointer;\n  }\n  \n  \n  .admin-details-back:hover {\n    color: #111827;\n  }\n  \n  \n  /* =====================================\n     HEADING\n  ===================================== */\n  \n  .admin-details-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n  \n    margin-bottom: 28px;\n  }\n  \n  \n  .admin-details-heading h1 {\n    margin: 0;\n  \n    font-size: clamp(\n      23px,\n      4vw,\n      30px\n    );\n  \n    font-weight: 700;\n  \n    color: #101828;\n  \n    overflow-wrap: anywhere;\n  }\n  \n  \n  .admin-details-heading p {\n    margin: 7px 0 0;\n  \n    font-size: 14px;\n  \n    color: #667085;\n  \n    overflow-wrap: anywhere;\n  }\n  \n  \n  /* =====================================\n     STATUS\n  ===================================== */\n  \n  .admin-details-status {\n    display: inline-flex;\n    align-items: center;\n  \n    flex-shrink: 0;\n  \n    padding: 7px 12px;\n  \n    border-radius: 999px;\n  \n    font-size: 13px;\n    font-weight: 600;\n  \n    white-space: nowrap;\n  }\n  \n  \n  .admin-details-status.pending {\n    background: #fff7e6;\n    color: #b54708;\n  }\n  \n  \n  .admin-details-status.verified {\n    background: #ecfdf3;\n    color: #027a48;\n  }\n  \n  \n  .admin-details-status.rejected {\n    background: #fef3f2;\n    color: #b42318;\n  }\n  \n  \n  /* =====================================\n     SECTIONS\n  ===================================== */\n  \n  .admin-details-section {\n    margin-bottom: 22px;\n  \n    padding: 24px;\n  \n    background: #ffffff;\n  \n    border:\n      1px solid #e8eaf0;\n  \n    border-radius: 14px;\n  \n    box-sizing: border-box;\n  }\n  \n  \n  .admin-details-section h2 {\n    margin:\n      0 0 22px;\n  \n    font-size: 18px;\n    font-weight: 650;\n  \n    color: #101828;\n  }\n  \n  \n  /* =====================================\n     GRID\n  ===================================== */\n  \n  .admin-details-grid {\n    display: grid;\n  \n    grid-template-columns:\n      repeat(\n        3,\n        minmax(0, 1fr)\n      );\n  \n    gap: 20px;\n  }\n  \n  \n  /* =====================================\n     INFO ITEM\n  ===================================== */\n  \n  .admin-info-item {\n    min-width: 0;\n  \n    display: flex;\n    flex-direction: column;\n  \n    gap: 6px;\n  }\n  \n  \n  .admin-info-item span {\n    font-size: 12px;\n    font-weight: 500;\n  \n    color: #667085;\n  }\n  \n  \n  .admin-info-item strong {\n    font-size: 14px;\n    font-weight: 600;\n  \n    color: #101828;\n  \n    overflow-wrap: anywhere;\n    word-break: break-word;\n  }\n  \n  \n  /* =====================================\n     EMPTY\n  ===================================== */\n  \n  .admin-details-empty,\n  .admin-documents-empty {\n    padding: 18px;\n  \n    background: #f8fafc;\n  \n    border-radius: 10px;\n  \n    font-size: 14px;\n    line-height: 1.6;\n  \n    color: #667085;\n  }\n  \n  \n  /* =====================================\n     DOCUMENTS\n  ===================================== */\n  \n  .admin-documents-list {\n    display: flex;\n    flex-direction: column;\n  \n    gap: 12px;\n  }\n  \n  \n  .admin-document-card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  \n    gap: 20px;\n  \n    padding: 16px;\n  \n    border:\n      1px solid #e8eaf0;\n  \n    border-radius: 12px;\n  \n    background: #ffffff;\n  \n    min-width: 0;\n  }\n  \n  \n  .admin-document-info {\n    display: flex;\n    align-items: center;\n  \n    gap: 13px;\n  \n    min-width: 0;\n    flex: 1;\n  }\n  \n  \n  .admin-document-icon {\n    width: 42px;\n    height: 42px;\n  \n    flex-shrink: 0;\n  \n    display: flex;\n    align-items: center;\n    justify-content: center;\n  \n    border-radius: 10px;\n  \n    background: #f2f4f7;\n  \n    color: #475467;\n  }\n  \n  \n  .admin-document-info > div:last-child {\n    min-width: 0;\n  }\n  \n  \n  .admin-document-info strong {\n    display: block;\n  \n    margin-bottom: 4px;\n  \n    font-size: 14px;\n  \n    color: #101828;\n  \n    overflow-wrap: anywhere;\n  }\n  \n  \n  .admin-document-info span {\n    display: block;\n  \n    max-width: 420px;\n  \n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  \n    font-size: 12px;\n  \n    color: #667085;\n  }\n  \n  \n  /* =====================================\n     DOCUMENT ACTIONS\n  ===================================== */\n  \n  .admin-document-actions {\n    display: flex;\n    align-items: center;\n  \n    gap: 8px;\n  \n    flex-shrink: 0;\n  }\n  \n  \n  .admin-document-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  \n    gap: 7px;\n  \n    padding: 8px 11px;\n  \n    border:\n      1px solid #d0d5dd;\n  \n    border-radius: 8px;\n  \n    background: #ffffff;\n  \n    text-decoration: none;\n  \n    font-size: 12px;\n    font-weight: 600;\n  \n    color: #344054;\n  \n    white-space: nowrap;\n  }\n  \n  \n  .admin-document-button:hover {\n    background: #f9fafb;\n  }\n  \n  \n  /* =====================================\n     REVIEW ACTIONS\n  ===================================== */\n  \n  .admin-review-actions {\n    display: flex;\n    justify-content: flex-end;\n  \n    gap: 12px;\n  \n    padding:\n      20px 0 40px;\n  }\n  \n  \n  .admin-delete-button,\n  .admin-reject-button,\n  .admin-verify-button {\n    min-height: 44px;\n  \n    padding:\n      12px 18px;\n  \n    border-radius: 10px;\n  \n    font-size: 14px;\n    font-weight: 600;\n  \n    cursor: pointer;\n  }\n\n  .admin-delete-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    border: 1px solid #b42318;\n    background: #b42318;\n    color: #ffffff;\n    box-shadow: 0 8px 18px rgba(180, 35, 24, 0.18);\n  }\n\n  .admin-delete-button:hover {\n    border-color: #912018;\n    background: #912018;\n  }\n  \n  \n  .admin-reject-button {\n    border:\n      1px solid #f04438;\n  \n    background: #ffffff;\n  \n    color: #d92d20;\n  }\n  \n  \n  .admin-reject-button:hover {\n    background: #fef3f2;\n  }\n  \n  \n  .admin-verify-button {\n    border:\n      1px solid #1570ef;\n  \n    background: #1570ef;\n  \n    color: #ffffff;\n  }\n  \n  \n  .admin-verify-button:hover {\n    background: #175cd3;\n  }\n  \n  \n  .admin-delete-button:disabled,\n  .admin-reject-button:disabled,\n  .admin-verify-button:disabled {\n    opacity: 0.6;\n  \n    cursor: not-allowed;\n  }\n  \n  \n  /* =====================================\n     STATES\n  ===================================== */\n  \n  .admin-details-state,\n  .admin-details-error {\n    padding: 40px 20px;\n  \n    background: #ffffff;\n  \n    border:\n      1px solid #e8eaf0;\n  \n    border-radius: 14px;\n  \n    text-align: center;\n  }\n  \n  \n  .admin-details-state {\n    color: #667085;\n  }\n  \n  \n  .admin-details-error {\n    color: #b42318;\n  }\n  \n  \n  /* =====================================\n     SMALL LAPTOP / TABLET\n  ===================================== */\n  \n  @media (max-width: 1100px) {\n  \n    .admin-details-grid {\n      grid-template-columns:\n        repeat(\n          2,\n          minmax(0, 1fr)\n        );\n    }\n  \n  }\n  \n  \n  /* =====================================\n     TABLET\n  ===================================== */\n  \n  @media (max-width: 800px) {\n  \n    .admin-details-heading {\n      align-items: flex-start;\n    }\n  \n  \n    .admin-details-section {\n      padding: 20px;\n    }\n  \n  \n    .admin-document-card {\n      align-items: flex-start;\n      flex-direction: column;\n    }\n  \n  \n    .admin-document-actions {\n      width: 100%;\n    }\n  \n  \n    .admin-document-button {\n      flex: 1;\n    }\n  \n  }\n  \n  \n  /* =====================================\n     MOBILE\n  ===================================== */\n  \n  @media (max-width: 600px) {\n  \n    .admin-details-back {\n      margin-bottom: 18px;\n  \n      font-size: 13px;\n    }\n  \n  \n    .admin-details-heading {\n      align-items: flex-start;\n      flex-direction: column;\n  \n      gap: 12px;\n  \n      margin-bottom: 20px;\n    }\n  \n  \n    .admin-details-grid {\n      grid-template-columns:\n        1fr;\n  \n      gap: 16px;\n    }\n  \n  \n    .admin-details-section {\n      margin-bottom: 14px;\n  \n      padding: 18px 16px;\n  \n      border-radius: 12px;\n    }\n  \n  \n    .admin-details-section h2 {\n      margin-bottom: 18px;\n  \n      font-size: 16px;\n    }\n  \n  \n    .admin-document-card {\n      padding: 14px;\n    }\n  \n  \n    .admin-document-info {\n      align-items: flex-start;\n  \n      width: 100%;\n    }\n  \n  \n    .admin-document-info span {\n      max-width: 100%;\n    }\n  \n  \n    .admin-document-actions {\n      display: grid;\n  \n      grid-template-columns:\n        repeat(\n          2,\n          minmax(0, 1fr)\n        );\n  \n      width: 100%;\n    }\n  \n  \n    .admin-document-button {\n      min-width: 0;\n  \n      padding:\n        10px 8px;\n    }\n  \n  \n    .admin-review-actions {\n      position: sticky;\n  \n      bottom: 0;\n  \n      z-index: 500;\n  \n      flex-direction: column-reverse;\n  \n      gap: 9px;\n  \n      margin:\n        0 -14px;\n  \n      padding:\n        14px;\n  \n      background:\n        rgba(\n          246,\n          247,\n          251,\n          0.96\n        );\n  \n      border-top:\n        1px solid #e8eaf0;\n  \n      backdrop-filter:\n        blur(10px);\n    }\n  \n  \n    .admin-delete-button,\n    .admin-reject-button,\n    .admin-verify-button {\n      width: 100%;\n  \n      min-height: 46px;\n    }\n  \n  }\n  \n  \n  /* =====================================\n     VERY SMALL MOBILE\n  ===================================== */\n  \n  @media (max-width: 380px) {\n  \n    .admin-details-section {\n      padding:\n        16px 13px;\n    }\n  \n  \n    .admin-document-actions {\n      grid-template-columns:\n        1fr;\n    }\n  \n  \n    .admin-review-actions {\n      margin:\n        0 -10px;\n  \n      padding:\n        10px;\n    }\n  \n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
